<button
  class="icon-button"
  [disabled]="loading()"
  [attr.aria-label]="ariaLabel()"
  (click)="handleOnClick()"
>
  @if (loading()) {
    <span class="icon-button__spinner"></span>
  } @else {
    <img [src]="'assets/images/icon-' + icon() + '.svg'" [alt]="ariaLabel()" />
  }
</button>
